const GuyanaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111564)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0004 0C16.4644 0 13.1434 0.918906 10.2612 2.52906V37.4709C13.1435 39.0811 16.4644 40 20.0004 40C31.046 40 40.0004 31.0456 40.0004 20C40.0004 8.95437 31.046 0 20.0004 0Z"
        fill="#6DA544"
      />
      <path
        d="M10.3195 2.49609C9.06127 3.19336 7.88643 4.02211 6.81307 4.9643C6.92158 4.86914 7.03119 4.77508 7.14166 4.68227L22.4592 19.9999L7.14158 35.3176C7.03104 35.2248 6.9215 35.1307 6.81299 35.0355C7.88635 35.9777 9.06127 36.8064 10.3194 37.5037L39.9998 19.9999L10.3195 2.49609Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.63094 3.5459C8.02102 3.96824 7.43523 4.4227 6.87703 4.9084L20.0005 20.0004L6.87695 35.0925C7.43516 35.5782 8.02094 36.0327 8.63086 36.455L36.5769 20.0004L8.63094 3.5459Z"
        fill="#FFDA44"
      />
      <path
        d="M7.14141 4.68262C6.6968 5.05621 6.26773 5.44785 5.85742 5.85809L18.2605 20.0003L5.85742 34.1425C6.26773 34.5528 6.69672 34.9445 7.14141 35.3179L22.4591 20.0003L7.14141 4.68262Z"
        fill="black"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111564">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GuyanaSvg;
